import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import {
  ProfileActivityCard,
  ProfileInfoCard,
} from '../../../containers/Cards';
import UserProvider from '../../../containers/Providers/User';

const ProfileView = () => (
  <UserProvider>
    <Fade>
      <Container fluid className="mt-3">
        <Row>
          <Col>
            <ProfileInfoCard />
          </Col>
          <Col>
            {/* <Row noGutters className="mb-3">
              <Col>
                <ProfileControlCard />
              </Col>
            </Row> */}
            <Row noGutters>
              <Col>
                <ProfileActivityCard />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fade>
  </UserProvider>
);
export default ProfileView;
